// Чистая «модель кадра» разбора: по ply → всё, что нужно нарисовать на экране
// (позиция, последний ход, маркер качества, win% для шкалы, позиция курсора графика,
// границы навигации). Единый источник истины для game.ts: и обычная навигация, и
// выход из «своего варианта»/«игры с движком» красят доску через один и тот же кадр.
// Без DOM — покрыт юнит-тестами.
import { winPct } from '@ext/core/evals';
import type { MoveQuality } from '@ext/core/classify';
import type { ReviewModel } from './review-model';

export interface FrameModel {
  /** Нормализованный полуход (0 = стартовая позиция). */
  ply: number;
  fen: string;
  last: { from: string; to: string } | null;
  marker: { square: string; quality: MoveQuality } | null;
  /** win% белых для eval bar (0..100). */
  whitePct: number;
  /** Позиция курсора графика (0..100). */
  cursorPct: number;
  atStart: boolean;
  atEnd: boolean;
}

/** win% белых на позиции после `ply`-го полухода (0 = старт). */
export function whitePctAt(m: ReviewModel, ply: number): number {
  const cp = ply === 0 ? null : m.moves[ply - 1]?.evalAfterCp ?? null;
  if (cp != null) return winPct(cp);
  if (m.graph.length && ply < m.graph.length) return m.graph[ply]!;
  return 50;
}

/** Описание кадра для позиции `plyRaw` (клампится в [0, n]). */
export function frameAt(m: ReviewModel, plyRaw: number): FrameModel {
  const n = m.moves.length;
  const ply = Math.max(0, Math.min(n, plyRaw));
  const cursorPct = (ply / Math.max(1, n)) * 100;
  if (ply === 0) {
    return { ply, fen: m.rootFen, last: null, marker: null, whitePct: whitePctAt(m, 0), cursorPct, atStart: true, atEnd: n === 0 };
  }
  const mv = m.moves[ply - 1]!;
  return {
    ply,
    fen: mv.fen,
    last: mv.from && mv.to ? { from: mv.from, to: mv.to } : null,
    marker: mv.quality && mv.to ? { square: mv.to, quality: mv.quality } : null,
    whitePct: whitePctAt(m, ply),
    cursorPct,
    atStart: false,
    atEnd: ply === n,
  };
}
